<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 14C0 11.0177 2.17554 8.54375 5.02637 8.07812C6.39706 5.6456 9.00522 4 12 4C15.7482 4 18.8919 6.57738 19.7607 10.0566C22.1612 10.423 24 12.4972 24 15C24 17.7614 21.7614 20 19 20H6C2.68628 20 7.93705e-05 17.3136 0 14ZM11 9C11 8.44772 11.4477 8 12 8C12.5523 8 13 8.44772 13 9V13.1309L14.4453 12.168C14.9048 11.8616 15.5257 11.9858 15.832 12.4453C16.1384 12.9048 16.0142 13.5257 15.5547 13.832L12.5547 15.832C12.2188 16.056 11.7812 16.056 11.4453 15.832L8.44531 13.832C7.98578 13.5257 7.86162 12.9048 8.16797 12.4453C8.47432 11.9858 9.09516 11.8616 9.55469 12.168L11 13.1309V9ZM2 14C2.00008 16.2091 3.79097 18 6 18H19C20.6569 18 22 16.6569 22 15C22 13.3431 20.6569 12 19 12C18.9825 12 18.9652 11.9997 18.9473 12C18.4433 12.0087 18.011 11.6415 17.9395 11.1426C17.5239 8.23566 15.0221 6 12 6C9.60446 6 7.53544 7.40401 6.57324 9.43848C6.41799 9.76674 6.09671 9.98503 5.73438 10.0088C3.64967 10.1452 2 11.8805 2 14Z"
    />
  </svg>
</template>
